import { ViewObjectParser } from "./view-object-parser";

export class ViewObjectContainerParser extends ViewObjectParser {
  constructor(viewObjectParsers, defaultViewObjects) {
    super();
    this.parsedFieldNames.push("_defaultViewObjects");
    this.viewObjectParsers = viewObjectParsers; // type: Map
    this.defaultViewObjects = defaultViewObjects; // type: Map
  }

  static parseItem(itemSetings, viewObjectParsers, defaultViewObjects) {
    let objType = itemSetings.type;
    let objParser = viewObjectParsers.get(objType);
    if (objParser === undefined) {
      return undefined;
    }
    let defaultObjSettings = defaultViewObjects.get(objType);
    itemSetings._defaultViewObjects = defaultViewObjects;
    return objParser.parse(itemSetings, defaultObjSettings);
  }

  static createSettings(settings, defaultSettings) {
    let parsedSettings = ViewObjectParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    parsedSettings._defaultViewObjects = settings._defaultViewObjects;
    return parsedSettings;
  }
}
